export default {
    name: 'DocLine',
    props: {
        language: {
            type: String,
            required: true
        },
        tokens: {
            type: Array,
            required: true
        }
    }
};
